import React from 'react';
import RegistroItem from './RegistroItem';

function RegistroList({ registros }) {
  return (
    <div className="row">
      <div className="col-xs-12 panel panel-default p-a-2">
        <table className="table">
          <thead>
            <tr>
              <th>CUIT</th>
              <th>Descripción</th>
              <th>Leyenda</th>
              <th>Fecha de Empadronado</th>
              <th>Periodo</th>
            </tr>
          </thead>
          <tbody>
            {registros.map((registro, index) => (
              <RegistroItem key={index} registro={registro} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RegistroList;
